import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import HotSection from "./components/HotSection";
import Ranking from "./components/Ranking";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-lg text-white shadow-none transition-all hover:bg-primary-600 ${
        visible ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line" aria-hidden="true" />
    </button>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <HotSection />
        <Ranking />
        <Reviews />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}